import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createRouterMiddleware } from '@lagunovsky/redux-react-router';
import createReducer from './reducers';
import rootSaga from './sagas';

const enhancers = [];
const sagaMiddleware = createSagaMiddleware();

const configureStore = (initialState = {}, history) => {
    const middleware = [
        sagaMiddleware,
        createRouterMiddleware(history),
    ];

    if (process.env.NODE_ENV === 'development') {
        const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

        if (typeof devToolsExtension === 'function') {
            enhancers.push(devToolsExtension());
        }
    }

    const composedEnhancers = compose(
        applyMiddleware(...middleware),
        ...enhancers,
    );

    const store = createStore(
        createReducer(history),
        initialState,
        composedEnhancers,
    );

    sagaMiddleware.run(rootSaga);
    return store;
};

export default configureStore;
